import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';

import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';
import {
  Available,
  ButtonDivision,
  CardCustom,
  CardInput,
  CenterHeaderQuantity,
  CloseIconStyled as IconStyled,
  ContainerCustom,
  InputApply,
  LeftHeaderQuantity,
  LefItemQuantity,
  LoadingIcon,
  TextQuantity,
  Title,
  TitlePage as IconsTop,
  ValueQuantity,
  IconInformationBlue,
  ToolTipText,
  ToolTipButton,
} from './styles';
import '~/components/styles/Global.css';
import close from '~/assets/images/close.png';
import api from '~/services/api';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import back from '~/assets/images/back.svg';
import RedirectToInitial from '~/components/layout/Logistic/RedirectToInitial';
import RedirectToPortal from '~/components/layout/Logistic/RedirectToPortal';
import { InfoButton } from '~/components/layout/Buttons';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import information from "~/assets/images/information-blue.svg";
import ReactTooltip from "react-tooltip";


export default function FinancialDiscount() {
  const dispatch = useDispatch();
  const history = useHistory();
  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticReducer = useSelector(state => state.logisticReducer);

  const [loadingPage, setLoadingPage] = useState(true);
  const [inputValues, setInputValues] = useState([]);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [financialDiscount, setFinancialDiscount] = useState(false);
  const [modalRedirect, setModalRedirect] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);

  const isMobile = window.screen.width < 771;

  const descriptions = {
    AV_CR_DCTO_CM_HUB_BA: isMobile ? 'Desc. HUB'    : 'Desconto comercial HUB',
    AV_CR_DESC_AVULSO:    isMobile ? 'Desc. avulso'           : 'Desconto avulso',
    AV_CR_DES_ADTOPIXBA:  isMobile ? 'Desc. PIX' : 'Desconto adiantamento PIX',
    AV_CR_DES_ADTOPIXUG:  isMobile ? 'Desc. PIX' : 'Desconto adiantamento PIX',
    AV_CR_DSCTO_COM_HUB:  isMobile ? 'Desc. HUB'    : 'Desconto comercial HUB',
    AV_CR_DST_LAPIDARBA:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar',
    AV_CR_DST_LAPIDARUG:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar',
    reweighingValue:      'Repesagem',
    shippingTaxDiscount:  'Taxa de entrega'
  };

  useEffect(() => {
    if (logisticReducer?.financialDiscount?.applied) {
      setInputValues(logisticReducer.financialDiscount.data);
    }
  }, []);

  useEffect(() => {
    console.log("logistic reducer discount --> ", logisticReducer)
  }, []);

  const getDiscounts = async () => {

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const orderId = logisticReducer.orderDraft.response.orderId;
    const storeId = localStorage.getItem('storeId');
    const supplyBrancheId = logisticReducer.business.supplyBranches[logisticReducer.selectedBranch].id;
    const url = `/sales/order/v2/orders-ga/${orderId}/discounts?accountId=${storeId}&order-id=${orderId}&branchId=${supplyBrancheId}`;

    try {
      const res = await api.get(url, parameters);
      if(res && res.data) {
        const data = createDiscountPayload(logisticReducer.replacement.response, res.data);
        setFinancialDiscount(data);
      }
      setLoadingPage(false);
    } catch (err) {
      console.log('err => ', err);
      const erro = err.response.status
      if (erro == 422) {
        handleToNext()
      } else {
        toast.error('Ocorreu um erro ao obter os descontos. Tente novamente mais tarde.');
        setTimeout(() => {
          setLoadingPage(false);
          history.push('/portal');
        }, 2000);
      }
    }
  };


  useEffect(() => {
    getDiscounts();
  }, []);

  function createDiscountPayload(valoration, discountInfo) {
    try {
       const additionalInformation = [
        ...discountInfo.discounts.creditNotes.map(creditNote => ({
            type: creditNote.type,
            available: creditNote.value
        })),
        {
            type: "reweighingValue",
            available: discountInfo.discounts.reweighingValue
        },
        {
          type: "shippingTaxDiscount",
          available: valoration.shippingTaxDiscount
        }
      ];

      return {
        initialOrderValue: valoration.total,
        appliedReplacements: discountInfo.discounts.reweighingValue,
        orderTotal: valoration.total,
        discountsToApply: valoration.discountLimit,
        additionalInformation: additionalInformation
      };
    } catch (error) {
      console.log("Error in mount discount", error);
      return {}
    }
  }

  function getPayloadReserveDiscount() {
    const reweighingValue = inputValues.find((item) => item && item.type === 'reweighingValue');

    const creditNotes = inputValues
      .filter((item) => item && item.type !== 'reweighingValue' && item.type !== 'shippingTaxDiscount')
      .map((item) => ({
        type: item.type,
        usedValue: item.numeric,
      }));

    const reweighingDiscountValue = reweighingValue && reweighingValue.numeric > 0 ? reweighingValue.numeric : undefined;

    return {
      ...(reweighingDiscountValue !== undefined && { reweighingDiscountValue }),
      creditNotes,
    };
  }


  const resetPayload = () => {
    const resetNumericValues = (obj) => {
      const newObj = { ...obj };

      const recursiveZero = (value) => {
        if (typeof value === 'number') {
          return 0;
        } else if (Array.isArray(value)) {
          return value.map(recursiveZero);
        } else if (typeof value === 'object' && value !== null) {
          const result = {};
          for (const key in value) {
            result[key] = recursiveZero(value[key]);
          }
          return result;
        }
        return value;
      };

      for (const key in newObj) {
        newObj[key] = recursiveZero(newObj[key]);
      }

      return newObj;
    };

    const resetNumericValuesForTypes = (types) => {
      const resultObject = {
        reweighingDiscountValue: 0,
        creditNotes: types.map(type => {
          return {
            type,
            usedValue: 0
          };
        })
      };

      return resultObject;
    };

    const desiredTypes = [
      "AV_CR_DCTO_CM_HUB_BA",
      "AV_CR_DESC_AVULSO",
      "AV_CR_DES_ADTOPIXBA",
      "AV_CR_DES_ADTOPIXUG",
      "AV_CR_DSCTO_COM_HUB",
      "AV_CR_DST_LAPIDARBA",
      "AV_CR_DST_LAPIDARUG"
    ];

    const zeroedObject = resetNumericValuesForTypes(desiredTypes);
    const finalResult = resetNumericValues(zeroedObject);

    return finalResult;
  };

  async function reserveDiscount() {

    setLoadingConfirm(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    let payload

    if (inputValues.some(item => item && item.numeric && item.numeric > 0)) {
        toast.success("Desconto aplicado com sucesso.")
        payload = getPayloadReserveDiscount();
      } else {
        payload = resetPayload();
        setInputValues([])
      }

    await api
      .post(`/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}/discounts/reserve`, payload, parameters)
      .then(res => {

        if (res.status === 200 || res.status === 201 ) {
          if (inputValues.some(item => item && item.numeric && item.numeric > 0)) {
            toast.success(res.data.message)
          }
        }

        handleToNext(payload)

      })
      .catch(err => {
        setLoadingConfirm(false);
        const erro = err.response;
        if (erro.status) {
          const message = err.response.data.message;
          if (message) {
              toast.error(message)
          } else {
            toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
            setLoadingPage(false);
            history.push('/portal')
          }
        }
      });
  };

  function formatCurrency(value) {
    const numericValue = parseFloat(value);

    if (isNaN(numericValue) || numericValue < 0) {
      return '0,00';
    }

    return numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function handleChange(event, index, type, available) {
    const rawValue = event.target.value.replace(/\D/g, '');
    const numericValue = Number(rawValue) / 100;
     if (numericValue <= available && verifyLimit(numericValue, type)) {
        setInputValues(prevQuantities => {
        const newQuantities = [...prevQuantities];
        newQuantities[index] = { type: type, value: rawValue, numeric: numericValue };
        return newQuantities;
      });
    }

  };

  function getValueForType(type) {
    if (!Array.isArray(inputValues)) {
      return null;
    }
    return inputValues.find((item) => item?.type === type);
  }

  function sumValues() {
    if (!Array.isArray(inputValues)) {
      return 0;
    }

    return inputValues.reduce((sum, obj) => sum + parseFloat(obj?.numeric || 0), 0) + parseFloat(logisticReducer.replacement.response.shippingTaxDiscount);
  }

  function sumValuesWithoutShippingTaxDiscount() {
    if (!Array.isArray(inputValues)) {
      return 0;
    }

    return inputValues.reduce((sum, obj) => sum + parseFloat(obj?.numeric || 0), 0);
  }


  function verifyLimit(numericValue, type) {
    const valueSome = inputValues.reduce((sum, obj) => {
      if (obj?.numeric && obj.type !== type) {
        return sum + parseFloat(obj.numeric, 10);
      }
      return sum;
    }, 0);


    const valueTotal = parseFloat(valueSome) + parseFloat(numericValue)
    return valueTotal <= parseFloat(financialDiscount.discountsToApply)
  }

  function handleToNext(payload) {

    if (payload) {
      dispatch({
        type: 'SET_FINANCIAL_DISCOUNT',
        financialDiscountData: {
          applied: true,
          payload: payload,
          data: inputValues
        }
      });
    }
    setTimeout(() => {
      setLoadingConfirm(false);
      history.push('/resumo-do-pedido');
    }, 2000);

  }

  const handleBack = () => {
    if (logisticReducer.replacement.applied) {
      history.push('/composicao-financeira-reposicoes');
    } else {
      if (logisticReducer.subsidized.applied) {
        history.push('/vasilhames-subsidiados');
      } else {
        if (logisticReducer.previousPage === '/criar-pedido') {
          setModalRedirect(true)
        } else {
          history.push(logisticReducer.previousPage);
        }
      }
    }
  }

  return (
    <Container>
      <IconsTop>
        <IconStyled
          src={back}
          alt="Ícone voltar"
          onClick={() => handleBack()}
        />
        <IconStyled
          src={close}
          alt="Ícone fechar"
          onClick={() => setModalCancel(true)}
        />
      </IconsTop>
      <RedirectToInitial
        modalRedirect={modalRedirect}
        setModalRedirect={setModalRedirect}
      />
      <RedirectToPortal
        modalRedirect={modalCancel}
        setModalRedirect={setModalCancel}
      />
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
        {loadingPage ? (
          <Loading loadingColor={'white'} />
        ) : (
        <>
        <CardOrder>
          <MainContainer>
            <Title>
              <span>Composição Financeira - Descontos</span>
            </Title>
            <Stepper activeStep={5} steps={7} />
            <CardInput>
              <Row className="p-0 justify-content-between">
                <Col className="p-0 text-left">
                  <TextQuantity style={{ marginBottom: '0.3rem' }}>Valor Inicial do Pedido</TextQuantity>
                </Col>
                <Col className="p-0 text-right">
                  <ValueQuantity style={{ marginBottom: '0.3rem' }}>{formatCurrency(parseFloat(logisticReducer.inicialOrderValue))}</ValueQuantity>
                </Col>
              </Row>
              <Row className="p-0 justify-content-between">
                <Col className="p-0 text-left">
                  <TextQuantity style={{ marginBottom: '0.3rem' }}>Reposições Aplicadas</TextQuantity>
                </Col>
                <Col className="p-0 text-right">
                <ValueQuantity style={{ marginBottom: '0.3rem' }}>
                    {parseFloat(logisticReducer.inicialOrderValue) - parseFloat(logisticReducer.replacement.response.total) + parseFloat(logisticReducer.replacement.response.replacementDiscount) > 0 ?
                      `-${formatCurrency(Math.abs(parseFloat(logisticReducer.inicialOrderValue) - parseFloat(logisticReducer.replacement.response.total) + parseFloat(logisticReducer.replacement.response.replacementDiscount)))}` :
                         formatCurrency(parseFloat(logisticReducer.inicialOrderValue) - parseFloat(logisticReducer.replacement.response.total) + parseFloat(logisticReducer.replacement.response.replacementDiscount))
                    }
                </ValueQuantity>
                </Col>
              </Row>
              {financialDiscount && financialDiscount?.additionalInformation?.map((info, index) => (
                info.available !== 0 && info.type === 'shippingTaxDiscount' && (
                  <Row className="p-0 align-items-center">
                      <Col xs="auto" className="p-0 text-left">
                        <TextQuantity style={{ marginBottom: '0.3rem' }}>
                            {descriptions[info.type]}
                        </TextQuantity>
                      </Col>
                      <Col xs="auto" className="p-0">
                        <ToolTipButton data-tip data-for={`tooltip${index}`}>
                          <img src={information} style={IconInformationBlue} />
                          <ReactTooltip id={`tooltip${index}`} place="right" type="dark" effect="solid">
                            <ToolTipText>Desconto referente as reposições aplicadas de vale gás</ToolTipText>
                          </ReactTooltip>
                        </ToolTipButton>
                      </Col>
                      <Col className="p-0 text-right">
                        <ValueQuantity style={{ marginBottom: '0.3rem' }}>
                            -{formatCurrency(info.available)}
                        </ValueQuantity>
                      </Col>
                  </Row>
                )
              ))}
              <Row className="p-0 justify-content-between">
                <Col className="p-0 text-left">
                <TextQuantity style={{ marginBottom: '0.3rem' }}>Subtotal do Pedido</TextQuantity>
                </Col>
                <Col className="p-0 text-right">
                  <ValueQuantity style={{ marginBottom: '0.3rem' }}>{formatCurrency(parseFloat(logisticReducer.replacement.response.total) - parseFloat(logisticReducer.replacement.response.replacementDiscount) - parseFloat(logisticReducer.replacement.response.shippingTaxDiscount))}</ValueQuantity>
                </Col>
              </Row>
            </CardInput>
            <ContainerCustom>
            <Row className="p-0 d-flex flex-nowrap" style={{ padding: '0rem', maxWidth: '100%', marginLeft: 'initial' }}>
              <Col className="p-0 ml-auto">
                <TextQuantity>Desconto máximo que poderá ser aplicado</TextQuantity>
              </Col>
              <Col className="p-0 ml-auto">
                <ValueQuantity>{formatCurrency(parseFloat(financialDiscount.discountsToApply) || 0)}</ValueQuantity>
              </Col>
            </Row>
            </ContainerCustom>
            <CardCustom>
              <Row style={{ padding: '0rem', maxWidth: '100%', marginLeft: 'initial'}}>
                <Col xs={4} className="p-0">
                  <LeftHeaderQuantity>&nbsp;</LeftHeaderQuantity>
                </Col>
                <Col xs={4} className="p-0">
                  <CenterHeaderQuantity>Disponível</CenterHeaderQuantity>
                </Col>
                <Col xs={4} className="p-0">
                  <CenterHeaderQuantity>Aplicar</CenterHeaderQuantity>
                </Col>
              </Row>
              {financialDiscount && financialDiscount?.additionalInformation?.map((info, index) => (
                <Row className="align-items-start" xs={2} key={index} style={{ padding: '0rem', maxWidth: '100%', marginLeft: 'initial', padding: '0rem 0.4rem 0rem 0.5rem'}}>
                  <>
                    {info.available !== 0 && info.type !== 'shippingTaxDiscount' && (
                      <>
                        <Col xs={4} className="p-0">
                          <LefItemQuantity>
                            {descriptions[info.type]}
                          </LefItemQuantity>
                        </Col>
                        <Col xs={4} className="p-0">
                          <Available>
                            {formatCurrency(parseFloat(info.available))}
                          </Available>
                        </Col>
                        <Col xs={4} className={ info.type === 'shippingTaxDiscount' && !isMobile ? 'p-2' : 'p-0'}>
                          <InputApply
                            disabled={info.type === 'shippingTaxDiscount'}
                            value={
                              info.type === 'shippingTaxDiscount'
                                ? formatCurrency(parseFloat(info.available))
                                : new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(Number(getValueForType(info.type)?.value || 0) / 100)
                            }
                            onChange={(event) => handleChange(event, index, info.type, info.available)}
                          />
                        </Col>
                      </>
                    )}
                  </>
                </Row>
              ))}
            </CardCustom>

            <ContainerCustom>
              <Row className="p-0 d-flex flex-nowrap" style={{ padding: '0rem', maxWidth: '100%', marginLeft: 'initial' }}>
                <Col className="p-0 ml-auto">
                  <TextQuantity>Desconto a aplicar</TextQuantity>
                </Col>
                <Col className="p-0 ml-auto">
                  <ValueQuantity>{formatCurrency(sumValuesWithoutShippingTaxDiscount() || 0)}</ValueQuantity>
                </Col>
              </Row>
            </ContainerCustom>

            <CardInput>
              <Row className="p-0 justify-content-between">
                <Col className="p-0 text-left">
                  <TextQuantity>Valor Final do Pedido</TextQuantity>
                </Col>
                <Col className="p-0 text-right">
                  <ValueQuantity>{formatCurrency(parseFloat(financialDiscount.orderTotal) - parseFloat(logisticReducer.replacement.response.replacementDiscount) - (sumValues() || 0))}</ValueQuantity>
                </Col>
              </Row>
            </CardInput>
            <ButtonDivision>
              <InfoButton
                style={{ margin: "-1rem 0 1rem 0" }}
                onClick={(e) => {
                 e.preventDefault()
                 if (inputValues.some(item => item && item.numeric && item.numeric > 0)) {
                    reserveDiscount()
                 } else {
                  setLoadingConfirm(true);
                  handleToNext()
                 }
                }}
              >
              {loadingConfirm ? (
                <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
              ) : (
                <div> Prosseguir</div>
              )}
              </InfoButton>
            </ButtonDivision>
          </MainContainer>
          <OpenChatBot backgroundColor={'#00f3ff'} />
        </CardOrder>
        </>
        )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
